// Modal Backdrop
.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;

  [data-theme='dark'] & {
    background: rgba(0, 0, 0, 0.7);
  }
}

// Modal Container
.modal {
  width: 100%;
  max-width: 440px;
  background: var(--color-surface-primary);
  border-radius: map.get($radius, 'lg');
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 40px);
}

// Header
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: map.get($spacing-scale, 'lg') map.get($spacing-scale, 'xl');
  border-bottom: 1px solid var(--color-grey-soft);
}

.title {
  @include heading-4;
  margin: 0;
  color: var(--color-text-primary);
}

.closeButton {
  flex-shrink: 0;
}

// Content
.content {
  flex: 1;
  overflow-y: auto;
  padding: map.get($spacing-scale, 'xl');
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'xl');
}

// Form field
.field {
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'sm');
}

.fieldLabel {
  @include body-small-medium;
  color: var(--color-text-secondary);
  margin: 0;
}

// Input override
.input {
  background-color: var(--color-surface-primary);
  border: 1px solid var(--color-grey-neutral);

  &:focus-within {
    border-color: var(--color-primary-base);
  }
}

// WhatsApp icon inside input - scale down to fit
.inputIcon {
  width: 20px;
  height: 20px;

  img {
    width: 20px;
    height: 20px;
  }
}

// Footer
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: map.get($spacing-scale, 'md');
  padding: map.get($spacing-scale, 'lg') map.get($spacing-scale, 'xl');
  border-top: 1px solid var(--color-grey-soft);
}

// Responsive adjustments
@media (max-width: $breakpoint-md) {
  .modal {
    max-width: 100%;
    border-radius: map.get($radius, 'md');
  }

  .header {
    padding: map.get($spacing-scale, 'md');
  }

  .content {
    padding: map.get($spacing-scale, 'md');
  }

  .footer {
    padding: map.get($spacing-scale, 'md');
  }
}
